import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: 'moi-thirdparty-summary',
    templateUrl: './moi-thirdparty-summary.component.html',
    styleUrls: ['./moi-thirdparty-summary.component.scss'],
    imports: [TranslatePipe, InputTooltipDirective],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiThirdPartySummaryComponent {
  private tabService = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() thirdpartyGUID: any;

  openThirdParty() {
    if (!this.thirdpartyGUID || !this.summaryModel.CanOpenParent) {
      return;
    }

    this.tabService.generateTab(this.pages.ThirdpartyDetail, this.thirdpartyGUID);
  }
}
